var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"54839976d33adb977b62e578e4f23b0beb70fb79"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["fontvisual"]={id:"54839976d33adb977b62e578e4f23b0beb70fb79"};
      